import JwtDecoder from "../lib/jwt";
import { getStoredToken } from "../services/auth.service";

export const getTenantId = () => {
  if (typeof window === "undefined") return "";
  const direct = localStorage.getItem("tenantId") || localStorage.getItem("tenant_id");
  if (direct) return direct;
  try {
    const token = getStoredToken();
    if (!token) return "";
    const payload = JwtDecoder.decode(token);
    return payload?.tenant_id || payload?.tenantId || "";
  } catch (err) {
    return "";
  }
};

export const getTenantIdOrDefault = () => {
  const tenantId = getTenantId();
  return tenantId || "6966a114411520d24490ade5";
};
